export const GET_TENANT_LIST = "/iam/tenant/list"
export const DELETE_TENANT = "/iam/tenant/:tenantId"
